import request from '@/plugin/axios'
import * as qs from 'qs'

/**
 * 水表状态
 * @param params
 * @returns {AxiosPromise}
 */
export function queryWaterRead (params) {
  return request({
    url: '/v1/electricity/webWaterReadMeterRecord/findLastRecord',
    method: 'get',
    params
  })
}

/**
 * 根据条件查询水表档案
 * @param params
 * @returns {AxiosPromise}
 */
export function queryWater (params) {
  return request({
    url: '/v1/electricity/webWaterArchive/findByCondition',
    method: 'get',
    params
  })
}

/**
 * 修改水表档案
 * @param data
 * @returns {AxiosPromise}
 */
export function updateWater (data) {
  return request({
    url: '/v1/electricity/webWaterArchive/updateWebWaterArchive',
    method: 'put',
    data
  })
}

/**
 * 新增水表档案
 * @param data
 * @returns {AxiosPromise}
 */
export function saveWater (data) {
  return request({
    url: '/v1/electricity/webWaterArchive/addWebWaterArchive',
    method: 'post',
    data
  })
}

/**
 * 水表开户
 * @param data
 * @returns {AxiosPromise}
 */
export function updateOpenAnAccountInBatches (data) {
  return request({
    url: '/v1/electricity/webWaterArchive/updateOpenAnAccountInBatches',
    method: 'post',
    data
  })
}

/**
 * 删除水表
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteWater (data) {
  return request({
    url: '/v1/electricity/webWaterArchive/deleteWebWaterArchive',
    headers: {
      'Content-Type': 'x-www-form-urlencoded'
    },
    method: 'delete',
    params: data
  })
}

/**
 * 查询未绑定水表的房间
 * @param params
 * @returns {AxiosPromise}
 */
export function findUserUnBind (params) {
  return request({
    url: '/v1/electricity/webWaterArchive/findUserUnBind',
    method: 'get',
    params
  })
}

/**
 * 房间绑定/解绑水表
 * @param {Object} data - 绑定数据
 * @param {Number} data.roomId - 房间ID
 * @param {Number} data.waterId - 水表ID
 * @param {Number} data.type - 操作类型：0-解绑，1-绑定
 * @returns {AxiosPromise}
 */
export function roomBindWaterMeter (data) {
  return request({
    url: '/v1/electricity/webWaterArchive/roomBindWaterMeter',
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 * 查询已绑定水表的房间
 * @param params
 * @returns {AxiosPromise}
 */
export function findRoomUser (params) {
  return request({
    url: '/v1/electricity/webWaterRechargeOrder/findBindRoomCode',
    method: 'get',
    params
  })
}

/**
 * 开关阀
 * @param data
 * @returns {AxiosPromise}
 */
export function updatewaterswith (data) {
  return request({
    url: '/v1/electricity/webWaterArchive/updateWaterStatus',
    method: 'put',
    data
  })
}

/**
 * 批量开关阀
 * @param data
 * @returns {AxiosPromise}
 */
export function updatewaterswithAll (data) {
  return request({
    url: '/v1/electricity/webWaterArchive/updateWaterStatusAll',
    method: 'put',
    data
  })
}

/**
 * 水表充值
 * @param data
 * @returns {AxiosPromise}
 */
export function waterchongzhi (data) {
  return request({
    url: '/v1/electricity/webWaterRechargeOrder/setWebWaterRechargeOrder',
    method: 'put',
    data
  })
}

/**
 *  条件多户设置免费电量
 * @param data
 * @returns {AxiosPromise}
 */
export function updateWaterFreeAll (data) {
  return request({
    url: '/v1/electricity/webWaterArchive/updateFreeAll',
    method: 'put',
    data
  })
}

/**
 *  单户设置水表状态
 * @param data
 * @returns {AxiosPromise}
 */
export function readWaterMeterSingle (data) {
  return request({
    url: '/v1/electricity/webWaterReadMeterRecord/readWaterMeterSingle',
    method: 'put',
    data
  })
}

/**
 *  批量读取水表状态
 * @param data
 * @returns {AxiosPromise}
 */
export function conditionReadWaterRecord (data) {
  return request({
    url: '/v1/electricity/webWaterReadMeterRecord/conditionReadWaterRecord',
    method: 'put',
    data
  })
}
